export default "__VITE_ASSET__2bb75df0__"